import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  authApp,
  emailIcon,
  phoneSms,
  reg_doodle,
  secQuest,
  textLogo,
} from "../../constant/import";
import { Button, InputField } from "../../components/forms";
import { emailReg, textReg } from "../../utils/regex";
import { useForm } from "react-hook-form";
import { TfiClose } from "react-icons/tfi";
import { MdClose, MdMarkEmailUnread, MdNavigateNext } from "react-icons/md";
import { MdPhonelinkLock } from "react-icons/md";
import { TbUserQuestion } from "react-icons/tb";
import { FaArrowRight } from "react-icons/fa6";
import { TbDeviceMobileMessage } from "react-icons/tb";
import { OTPnumber } from "../../components/auth/Number";
import { useEffect, useState } from "react";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { onGetOtp, onVerifyAccount, onVerifyOtp } from "../../services/auth/user";
import { FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";

const AnotherMethod = () => (
  <Link to="/chooseverify">
    <div className="px-4 py-3  flex justify-center items-center border-2 shadow-xs border-[#12121279] rounded-[8px] mt-10 ">
      <p className="font-semibold text-xs text-black cursor-pointer">
        Try Another Method
      </p>
    </div>
  </Link>
);

// const verifyOtp=async()=>{
// var res =

// }
const AnotherMethodItem = (props: any) => (
  <Link className="w-full" to={props.path}>
    <div className="px-4 py-3  flex justify-between items-center border-2 shadow-xs border-[#12121279] rounded-[8px] mt-6 w-full  ">
      <p className="font-semibold text-xs text-black cursor-pointer inline ">
        {props.title}{" "}
      </p>
      <FaArrowRight size={15} className="inline " />
    </div>
  </Link>
);

const VerifyEmail = (props:any) => {
  const { handleSubmit, control, watch } = useForm();
  const { isTabletOrMobile } = useStateGetter();
  const [enteredOTP, setEntered] = useState("");
  const watchedFields = watch(["email"]);
  const navigate = useNavigate();
  const { setLoading, showModal, setShowModal } = useStateSetter();
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );
  const { verifyemail } = useStateGetter();


 const resendOtp= async () => {
    setLoading(true);
    var postdata = { email: verifyemail };
    
    var res =await onGetOtp(postdata)
    setLoading(false);
    toast("OTP sent to your email")
  
    setShowModal(false);
  }

  useEffect(()=>{
if(verifyemail==""){
  navigate('/')
}
  },[])
  const onSubmit = () => {};

  const OnVerifySuccess = () => (
    <div className="">
      <p className=" font-medium text-textbg  my-2">
        {" "}
   Verification Successsfuly{" "}
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          disabled={false}
          text="Login"
          onBtnClick={() => {
            navigate("/");
            setShowModal(false);
          }}
        />
      </div>{" "}
    </div>
  );
  const OnVerifyFailed = () => (
    <div className="">
      <p className=" font-medium text-textbg  my-2">
        {" "}
        Verification Failed{" "}
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          disabled={false}
          text="Ok"
          onBtnClick={() => {
           
            setShowModal(false);
          }}
        />
      </div>{" "}
    </div>
  );
  const submitemailOTP = async () => {
    var postdata = {
      email: verifyemail,
      otp: enteredOTP,
    };


    try{

    
    setLoading(true);

    var res = await onVerifyOtp(postdata);
    setLoading(false);
    navigate("/verify");

    if (res.success) {
setLoading(true)
      var res1 = await onVerifyAccount({email:verifyemail});
setLoading(false)

   if(res1.success) {  showModal(
        "",
        "",
        <FaCheck
          size={30}
          className="inline  text-textbg bg-green-200 p-2 rounded-full"
        />,
        <OnVerifySuccess />
      );}
    }
    
  }
    catch(error:any){
       
      showModal(
        error,
        "",
        <MdClose
          size={30}
          className="inline  text-red-400 bg-green-200 p-2 rounded-full"
        />,
        <OnVerifyFailed />
      );
      setLoading(false)
    }

    console.log(enteredOTP);
  };

  return (
    <div className="p-4 md:p-10 w-screen h-screen bg-customGray  flex flex-col md:grid md:grid-cols-2 items-center justify-center">
      {!isTabletOrMobile && (
        <div className="px-30 py-10 flex flex-col gap-10 justify-center items-center ">
          <img className="w-[173px] mb-4 " src={textLogo} />
          <img className="w-[330px]  " src={reg_doodle} />
        </div>
      )}
      <div className="bg-white  w-[100%] md:w-[458px] p-6     md:mx-20 md:py-2 md:px-20 shadow flex flex-col  justify-center items-center">
        <img src={emailIcon} className="w-[55px] my-6" />

        <p className="font-bold text-textbg text-[24px] text-center ">
          Verify Your Email
        </p>
        <small className="font-light text-textbg text-xs text-center ">
          kindly enter the code sent to your email to complete the process{" "}
        </small>
        <div className=" my-4">
          <OTPnumber setEntered={setEntered} />

          <Button
            disabled={!(enteredOTP.length == 4)}
            text="Verify"
            onBtnClick={handleSubmit(submitemailOTP)}
          />

          <div className="flex justify-center items-center">
            <small className="font-medium text-textbg text-xs ">
              Didn't get code?{" "}
              <p className="text-primary" onClick={resendOtp}>
                Resend{" "}
              </p>
            </small>
          </div>

    {props.isfactor &&    <AnotherMethod />}
        </div>
      </div>
    </div>
  );
};




const VerifyResetEmail = (props:any) => {


  const { handleSubmit, control, watch } = useForm();
  const { isTabletOrMobile } = useStateGetter();
  const [enteredOTP, setEntered] = useState("");
  const watchedFields = watch(["email"]);
  const navigate = useNavigate();
  const { setLoading, showModal, setShowModal } = useStateSetter();
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );
  const { verifyemail } = useStateGetter();



  const resendOtp= async () => {
    setLoading(true);
    var postdata = { email: verifyemail };
    
    var res =await onGetOtp(postdata)
    setLoading(false);
    toast("OTP sent to your email")
  
    setShowModal(false);
  }


  useEffect(()=>{
if(verifyemail==""){
  navigate('/')
}
  },[])
  const onSubmit = () => {};
  
  const OnVerifySuccess = () => (
    <div className="">
      <p className=" font-medium text-textbg  my-2">
        {" "}
   Verification Successsfuly{" "}
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          disabled={false}
          text="Login"
          onBtnClick={() => {
            navigate("/");
            setShowModal(false);
          }}
        />
      </div>{" "}
    </div>
  );
  const OnVerifyFailed = () => (
    <div className="">
      <p className=" font-medium text-textbg  my-2">
        {" "}
        Verification Failed{" "}
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          disabled={false}
          text="Ok"
          onBtnClick={() => {
           
            setShowModal(false);
          }}
        />
      </div>{" "}
    </div>
  );
  const submitemailOTP = async () => {
    var postdata = {
      email: verifyemail,
      otp: enteredOTP,
    };


    try{

    
    setLoading(true);

    var res = await onVerifyOtp(postdata);
    setLoading(false);
    navigate("/verify");

    if (res.success) {

      navigate('/chagepassword')
    }
    
  }
    catch(error:any){
       
      showModal(
        error,
        "",
        <MdClose
          size={30}
          className="inline  text-red-400 bg-green-200 p-2 rounded-full"
        />,
        <OnVerifyFailed />
      );
      setLoading(false)
    }

    console.log(enteredOTP);
  };

  return (
    <div className="p-4 md:p-10 w-screen h-screen bg-customGray  flex flex-col md:grid md:grid-cols-2 items-center justify-center">
      {!isTabletOrMobile && (
        <div className="px-30 py-10 flex flex-col gap-10 justify-center items-center ">
          <img className="w-[173px] mb-4 " src={textLogo} />
          <img className="w-[330px]  " src={reg_doodle} />
        </div>
      )}
      <div className="bg-white  w-[100%] md:w-[458px] p-6     md:mx-20 md:py-2 md:px-20 shadow flex flex-col  justify-center items-center">
        <img src={emailIcon} className="w-[55px] my-6" />

        <p className="font-bold text-textbg text-[24px] text-center ">
          Verify Your Email
        </p>
        <small className="font-light text-textbg text-xs text-center ">
          kindly enter the code sent to your email to complete the process{" "}
        </small>
        <div className=" my-4">
          <OTPnumber setEntered={setEntered} />

          <Button
            disabled={!(enteredOTP.length == 4)}
            text="Verify"
            onBtnClick={handleSubmit(submitemailOTP)}
          />

          <div className="flex justify-center items-center">
            <small className="font-medium text-textbg text-xs ">
              Didn't get code?{" "}
              <p className="text-primary" onClick={resendOtp}>
                Resend{" "}
              </p>
            </small>
          </div>

    {props.isfactor &&    <AnotherMethod />}
        </div>
      </div>
    </div>
  );
};
const VerifySms = () => {
  const { handleSubmit, control, watch } = useForm();
  const { isTabletOrMobile } = useStateGetter();
  const [enteredOTP, setEntered] = useState("");
  const watchedFields = watch(["email"]);
  const navigate = useNavigate();
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );

  const onSubmit = () => {};

  return (
    <div className="p-4 md:p-10 w-screen h-screen bg-customGray  flex flex-col md:grid md:grid-cols-2 items-center justify-center">
      {!isTabletOrMobile && (
        <div className="px-30 py-10 flex flex-col gap-10 justify-center items-center ">
          <img className="w-[173px] mb-4 " src={textLogo} />
          <img className="w-[330px]  " src={reg_doodle} />
        </div>
      )}
      <div className="bg-white  w-[100%] md:w-[458px] p-6     md:mx-20 md:py-2 md:px-20 shadow flex flex-col  justify-center items-center">
        <img src={phoneSms} className="w-[55px] my-6" />

        <p className="font-bold text-textbg text-[22px] text-center ">
          Verify Via SMS to continue{" "}
        </p>
        <small className="font-light text-textbg text-xs text-center ">
          kindly enter the code sent to you via sms to login
        </small>
        <div className=" my-4">
          <OTPnumber setEntered={setEntered} />
          <Button
            disabled={!(enteredOTP.length == 4)}
            text="Verify"
            onBtnClick={handleSubmit(onSubmit)}
          />
          <div className="flex justify-center items-center">
            <small className="font-medium text-textbg text-xs ">
              Didn't get code?{" "}
              <Link className="text-primary" to="/">
                Resend{" "}
              </Link>
            </small>
          </div>
          <Link to="/verifyauthapp">
            <AnotherMethod />
          </Link>{" "}
        </div>
      </div>
    </div>
  );
};

const VerifyAuthApp = () => {
  const { handleSubmit, control, watch } = useForm();
  const { isTabletOrMobile } = useStateGetter();
  const [enteredOTP, setEntered] = useState("");
  const watchedFields = watch(["email"]);
  const navigate = useNavigate();
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );

  const onSubmit = () => {};

  return (
    <div className="p-4 md:p-10 w-screen h-screen bg-customGray  flex flex-col md:grid md:grid-cols-2 items-center justify-center">
      {!isTabletOrMobile && (
        <div className="px-30 py-10 flex flex-col gap-10 justify-center items-center ">
          <img className="w-[173px] mb-4 " src={textLogo} />
          <img className="w-[330px]  " src={reg_doodle} />
        </div>
      )}
      <div className="bg-white  w-[100%] md:w-[458px] p-6     md:mx-20 md:py-2 md:px-20 shadow flex flex-col  justify-center items-center">
        <img src={authApp} className="w-[55px] my-6" />

        <p className="font-bold text-textbg text-[22px] text-center ">
          Verify Via Authenticator App to continue{" "}
        </p>
        <small className="font-light text-textbg text-xs text-center ">
          Enter code generated by your authenticator app to confirm{" "}
        </small>
        <div className=" my-4">
          <OTPnumber setEntered={setEntered} />

          <Button
            disabled={!(enteredOTP.length == 4)}
            text="Verify"
            onBtnClick={handleSubmit(onSubmit)}
          />

          <div className="flex justify-center items-center">
            <small className="font-medium text-textbg text-xs ">
              Didn't get code?{" "}
              <Link className="text-primary" to="/">
                Resend{" "}
              </Link>
            </small>
          </div>
          <Link to="/verifysecquest">
            <AnotherMethod />
          </Link>
        </div>
      </div>
    </div>
  );
};

const VerifySecQuest = () => {
  const { handleSubmit, control, watch } = useForm();
  const { isTabletOrMobile } = useStateGetter();
  const [enteredOTP, setEntered] = useState("");
  const watchedFields = watch(["answer"]);
  const navigate = useNavigate();
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );

  const onSubmit = () => {};

  return (
    <div className="p-4 md:p-10 w-screen h-screen bg-customGray  flex flex-col md:grid md:grid-cols-2 items-center justify-center">
      {!isTabletOrMobile && (
        <div className="px-30 py-10 flex flex-col gap-10 justify-center items-center ">
          <img className="w-[173px] mb-4 " src={textLogo} />
          <img className="w-[330px]  " src={reg_doodle} />
        </div>
      )}
      <div className="bg-white  w-[100%] md:w-[458px] p-6     md:mx-20 md:py-2 md:px-20 shadow flex flex-col  justify-center items-center">
        <img src={secQuest} className="w-[55px] my-6" />

        <p className="font-bold text-textbg text-[22px] text-center ">
          Security Question{" "}
        </p>
        <small className="font-light text-textbg text-xs text-center ">
          Enter code generated by your authenticator app to confirm{" "}
        </small>
        <div className=" my-4">
          <p className="font-bold text-textbg text-[13px] text-center ">
            What is the name of your first school?{" "}
          </p>
          <InputField
            name="answer"
            title="Answer"
            placeholder="Enter answer"
            // onchange={onchange}
            control={control}
            rules={{
              required: "Last name is required",
              pattern: {
                value: textReg,
                message: "Invalid name",
              },
            }}
          />

          <Button
            disabled={!areFieldsFilled}
            text="Verify"
            onBtnClick={handleSubmit(onSubmit)}
          />

          <div className="flex justify-center items-center">
            <small className="font-medium text-textbg text-xs ">
              Didn't get code?{" "}
              <Link className="text-primary" to="/">
                Resend{" "}
              </Link>
            </small>
          </div>
          <Link to="/verify">
            <AnotherMethod />
          </Link>
        </div>
      </div>
    </div>
  );
};
const ChooseVerifyMethod = () => {
  const navigate = useNavigate();
  const { isTabletOrMobile } = useStateGetter();

  return (
    <div className="p-4 md:p-10 w-screen h-screen bg-customGray  flex flex-col md:grid md:grid-cols-2 items-center justify-center">
      {!isTabletOrMobile && (
        <div className="px-30 py-10 flex flex-col gap-10 justify-center items-center ">
          <img className="w-[173px] mb-4 " src={textLogo} />
          <img className="w-[330px]  " src={reg_doodle} />
        </div>
      )}
      <div className="bg-white  w-[100%] md:w-[458px] p-6     md:mx-20 md:py-14 md:px-20 shadow flex flex-col  justify-center items-center">
        <AnotherMethodItem title="Verify via SMS" path="/verifysms" />
        <AnotherMethodItem
          title="Verify via Authenticator App"
          path="/verifyauthapp"
        />
        <AnotherMethodItem
          title="Verify via Security Question"
          path="/verifysecquest"
        />
      </div>
    </div>
  );
};

export {
  VerifyEmail,
  ChooseVerifyMethod,
  VerifyAuthApp,
  VerifySecQuest,
  VerifySms,
  VerifyResetEmail
};
